import useQuery from '../../hooks/useQuery';
import permissions from '../../Apollo/permissions';
import { DISTINCT_ACTIONS_QUERY, buildVariables } from './distinct-actions-query-builder';

export default function useDistinctActions({ where, skip = false }) {
  const { data, loading, error, isAllowed } = useQuery(DISTINCT_ACTIONS_QUERY, {
    variables: buildVariables({ where }),
    skip,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-and-network',
    context: { permission: permissions.readAuditLogDebugData },
  });

  return { actions: (data?.org_audit_logs ?? []).map(row => row.action), loading, error, isAllowed };
}
